import { OpenSansText } from "@Components/CustomText/OpenSansText"
import React from "react"
import styles from "./styles"
import { TouchableOpacity, View } from "react-native"
import { baseColors } from "@Constants/baseStyles"
import CustomBottomModal from "@Components/Modal/CustomBottomModal/CustomBottomModal"
import { useNavigation } from "@react-navigation/native"

export const EvaluationResultModal = (props) => {
    const { open, toggleModal } = props
    const navigation = useNavigation()
    const handleCheckResult = () => {
        navigation.navigate("EvaluationStack")
        toggleModal()
    }

    return (
        <CustomBottomModal
            backgroundColor={baseColors.orange.primary}
            open={open}
            toggleModal={toggleModal}
            isSimplePopUp
        >
            <OpenSansText fontSize={16} color={"white"}>
                Vous avez terminé le quiz ! Retrouvez vos résultats dans la partie "Mon suivi" et l'onglet "Je
                m'évalue".
            </OpenSansText>

            <TouchableOpacity onPress={handleCheckResult} style={styles.results}>
                <OpenSansText
                    style={styles.resultLabel}
                    fontSize={14}
                    fontWeight="bold"
                    color={baseColors.orange.primary}
                >
                    VOIR LES RÉSULTATS
                </OpenSansText>
            </TouchableOpacity>
        </CustomBottomModal>
    )
}
